import { render, staticRenderFns } from "./DashIntakeReferrals.vue?vue&type=template&id=3b980ae4&scoped=true&"
import script from "./DashIntakeReferrals.vue?vue&type=script&lang=js&"
export * from "./DashIntakeReferrals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b980ae4",
  null
  
)

export default component.exports